//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ShareButtons',
  props: {
    shareUrl: {
      type: String,
      required: true
    },
    shareText: {
      type: String,
      default: ''
    }
  },
  computed: {
    whatsAppShareUrl () {
      return `https://wa.me/?text=${encodeURIComponent(`${this.shareText} ${this.shareUrl}`.trim())}`
    },
    facebookShareUrl () {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareUrl)}`
    },
    xShareUrl () {
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.shareText)}&url=${encodeURIComponent(this.shareUrl)}`
    },
    instagramProfileUrl () {
      const account = (this.$config.STORE_INSTAGRAM || '').replace('@', '').trim()
      return account ? `https://www.instagram.com/${account}/` : 'https://www.instagram.com/'
    }
  },
  methods: {
    async copyShareLink () {
      try {
        if (navigator && navigator.clipboard) {
          await navigator.clipboard.writeText(this.shareUrl)
          this.$notify.show({
            text: 'Link copiado',
            type: 'success',
            closeWait: 2000
          })
        }
      } catch (error) {
        this.$notify.show({
          text: 'No se pudo copiar el link',
          type: 'danger',
          closeWait: 2000
        })
      }
    },
    async shareOnInstagram () {
      try {
        if (navigator && navigator.clipboard) {
          await navigator.clipboard.writeText(this.shareUrl)
        }
        window.open(this.instagramProfileUrl, '_blank', 'noopener,noreferrer')
        this.$notify.show({
          text: 'Link copiado. Ahora pégalo en Instagram.',
          type: 'success',
          closeWait: 2500
        })
      } catch (error) {
        this.$notify.show({
          text: 'Abriendo Instagram, copia el link manualmente.',
          type: 'warning',
          closeWait: 2500
        })
        window.open(this.instagramProfileUrl, '_blank', 'noopener,noreferrer')
      }
    }
  }
}
